import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Understand industrial boilers, steam systems and heat exchangers. 6 visual PDF volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-zinc-950 font-sans text-zinc-300 antialiased" data-id="element-0" data-mp="nvsup6ui4rx0">
      <MetaPixel data-id="element-1" data-mp="su45bjsmf6ga" />
      <main data-id="element-2" data-mp="stkm7zr8ic0o">
        <Hero data-id="element-3" data-mp="stc6m03q8sls" />
        <LookInsideCarousel data-id="element-4" data-mp="sssr0q1jugax" />
        <ProblemSection data-id="element-5" data-mp="36hv93iy4lzn" />
        <SystemSection data-id="element-6" data-mp="35oz0whm5evr" />
        <ModulesSection data-id="element-7" data-mp="356rh3pi3e8j" />
        <BonusSection data-id="element-8" data-mp="38kvegdtbvi3" />
        <UrgencySection data-id="element-9" data-mp="3uct0zcywiaxb" />
        <PricingSection data-id="element-10" data-mp="3udkn7x6lywax" />
        <GuaranteeSection data-id="element-11" data-mp="3uc9k7zkzlskv" />
        <FAQ data-id="element-12" data-mp="3uf5i5nwu4h9b" />
        <ClosingSection data-id="element-13" data-mp="d4o0nv3yoa99" />
        <SummaryTable data-id="element-14" data-mp="d4xr1jsx4jfh" />
        <FinalCta data-id="element-15" data-mp="d45sc040y5kz" />
      </main>
      <Footer data-id="element-16" data-mp="d2bjhk6123x9" />
      <PurchaseNotification data-id="element-17" data-mp="85uihpdqbv2r" />
    </div>;
}